import angular from "angular";

import AboutModuleRouting from "./about.module.routing";

export default angular
    .module("vt-about", [])
    .config(AboutModuleRouting);
